module.exports = __webpack_public_path__ + "img/cross_white.f48352ac.svg";